// extracted by mini-css-extract-plugin
export default {"root":"input_root__2+l-t","error":"input_error__ksTSg"};